import { createSlice } from '@reduxjs/toolkit'
import { merge } from 'components/util'
import SeriesSnapshot from './series-snapshot-model'
import {
  CreateSeriesSnapshotAsync,
  DeleteSeriesSnapshotAsync,
  LoadSeriesSnapshotsAsync,
} from './seriesSnapshot-thunk'
const initialState: seriesSnapshotSliceState = {
  seriesSnapshot: [],
  selected_seriesSnapshot: '',
  is_loading_seriesSnapshot: false,
  is_creating_seriesSnapshot: false,
  is_deleting_seriesSnapshot: false,
}
export interface seriesSnapshotSliceState {
  seriesSnapshot: SeriesSnapshot[]
  selected_seriesSnapshot?: string
  is_loading_seriesSnapshot: boolean
  is_creating_seriesSnapshot: boolean
  is_deleting_seriesSnapshot: boolean
}
export const seriesSnapshotSlice = createSlice({
  name: 'seriesSnapshot',
  initialState,
  reducers: {
    setSelectedseriesSnapshot: (state, action) => {
      state.selected_seriesSnapshot = action.payload
    },
    clearStateseriesSnapshot: (state) => {
      state.seriesSnapshot = []
      state.is_loading_seriesSnapshot = false
      state.is_creating_seriesSnapshot = false
      state.is_deleting_seriesSnapshot = false
    },
    mergeseriesSnapshot: (state, action) => {
      if (action.payload) {
        let payload: any = action.payload
        if (payload?.data) {
          if (!Array.isArray(payload.data)) {
            state.selected_seriesSnapshot = payload?.data?.id
            payload = [payload.data]
          } else {
            payload = payload.data
          }
          state.seriesSnapshot = merge(state.seriesSnapshot, payload) as any
        }
      }
    },

    add_seriesSnapshot: (state, action) => {
      if (action.payload) {
        state.seriesSnapshot = [...state.seriesSnapshot, action.payload]
      }
    },
    set_seriesSnapshot: (state, action) => {
      let { key, value, id } = action.payload
      state.seriesSnapshot = state.seriesSnapshot.map((item) => {
        if (item && item.id === id) {
          return {
            ...item,
            [key]: value,
          }
        }
        return item
      })
    },
  },
  extraReducers: (builder) => {
    builder.addCase('LOGOUT', () => {
      return { ...initialState }
    })

    builder.addCase(LoadSeriesSnapshotsAsync.pending, (state) => {
      state.is_loading_seriesSnapshot = true
    })
    builder.addCase(LoadSeriesSnapshotsAsync.fulfilled, (state, action) => {
      state.is_loading_seriesSnapshot = false
      if (action.payload) {
        state.seriesSnapshot = action.payload
      }
    })
    builder.addCase(LoadSeriesSnapshotsAsync.rejected, (state) => {
      state.is_loading_seriesSnapshot = false
    })
    builder.addCase(CreateSeriesSnapshotAsync.pending, (state) => {
      state.is_creating_seriesSnapshot = true
    })
    builder.addCase(CreateSeriesSnapshotAsync.fulfilled, (state) => {
      state.is_creating_seriesSnapshot = false
    })
    builder.addCase(CreateSeriesSnapshotAsync.rejected, (state) => {
      state.is_creating_seriesSnapshot = false
    })
    builder.addCase(DeleteSeriesSnapshotAsync.pending, (state) => {
      state.is_deleting_seriesSnapshot = true
    })
    builder.addCase(DeleteSeriesSnapshotAsync.fulfilled, (state, action) => {
      state.is_deleting_seriesSnapshot = false
      if (state.seriesSnapshot) {
        state.seriesSnapshot = state.seriesSnapshot.filter(
          (x) => action.payload.id !== x.id,
        )
      }
    })
    builder.addCase(DeleteSeriesSnapshotAsync.rejected, (state) => {
      state.is_deleting_seriesSnapshot = false
    })
  },
})

export const {
  clearStateseriesSnapshot,
  setSelectedseriesSnapshot,
  set_seriesSnapshot,
  mergeseriesSnapshot,
  add_seriesSnapshot,
} = seriesSnapshotSlice.actions

export const get_seriesSnapshot =
  (id?: string) =>
  (state: {
    seriesSnapshot: {
      seriesSnapshot: SeriesSnapshot[]
    }
  }): SeriesSnapshot | null => {
    let temp = state?.seriesSnapshot?.seriesSnapshot?.find((v) => v.id === id)
    if (temp) {
      return temp
    }
    return state?.seriesSnapshot?.seriesSnapshot[0] || null
  }
export const get_selected_seriesSnapshot = (state: {
  seriesSnapshot: seriesSnapshotSliceState
}): SeriesSnapshot | null => {
  let id = state?.seriesSnapshot?.selected_seriesSnapshot
  let temp = state?.seriesSnapshot?.seriesSnapshot?.find((v) => v.id === id)
  if (temp) {
    return temp
  }
  return null
}
export const get_all_seriesSnapshot = (state: {
  seriesSnapshot: {
    seriesSnapshot: SeriesSnapshot[]
  }
}): SeriesSnapshot[] => {
  let temp = state?.seriesSnapshot?.seriesSnapshot
  if (temp) {
    return temp.filter((x) => !x.deleted)
  }
  return []
}
export const is_seriesSnapshot_busy = (state: {
  seriesSnapshot: seriesSnapshotSliceState
}) => {
  return (
    state?.seriesSnapshot.is_deleting_seriesSnapshot ||
    state?.seriesSnapshot.is_loading_seriesSnapshot ||
    state?.seriesSnapshot.is_creating_seriesSnapshot
  )
}
export const is_deleting_seriesSnapshot_busy = (state: {
  seriesSnapshot: seriesSnapshotSliceState
}) => {
  return state?.seriesSnapshot.is_deleting_seriesSnapshot
}
export const is_loading_seriesSnapshot_busy = (state: {
  seriesSnapshot: seriesSnapshotSliceState
}) => {
  return state?.seriesSnapshot.is_loading_seriesSnapshot
}
export const is_creating_seriesSnapshot_busy = (state: {
  seriesSnapshot: seriesSnapshotSliceState
}) => {
  return state?.seriesSnapshot.is_creating_seriesSnapshot
}

export default seriesSnapshotSlice.reducer
